import type { ParentComponent } from "../../lib/types";

const Normal: ParentComponent = ({ children }) => (
	<p className="font-serif text-sm leading-[1.6] text-foreground not-last:mb-[0.5lh] desktop:text-md">
		{children}
	</p>
);

export { Normal };
